// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1I05A","toggleWrap":"styles_toggleWrap__1ZJUA","content":"styles_content__3k6pu","selectAreaCode":"styles_selectAreaCode__28q9C"};